module.exports = __webpack_public_path__ + "static/media/backWave8.807aa02d.svg";